import { render, staticRenderFns } from "./customtablefield.vue?vue&type=template&id=4bc229c0&"
import script from "./customtablefield.vue?vue&type=script&lang=js&"
export * from "./customtablefield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports